import { Component } from '@angular/core';
import { Product } from '../../../../../common/js/static/Product';
import type { CasApplication } from '../../../../classes/coverpath_subclasses/CasApplication';
import type { CoverpathBasePolicy } from '../../../../classes/coverpath_subclasses/CoverpathBasePolicy';
import { PolicyDetailsComponent } from '../policy-details/policy-details.component';

@Component({
  moduleId: module.id,
  selector: 'policy-details-ny',
  templateUrl: './policy-details-ny.component.html',
})
export class PolicyDetailsNyComponent extends PolicyDetailsComponent {
  getPolicyText(): string {
    const application: CasApplication = this.controller.customer.application as CasApplication;
    if (application.isJointApp()) {
      const secondaryPolicy: CoverpathBasePolicy = application.secondaryPolicy;
      const termText: string = secondaryPolicy.isAnnuallyRenewableTerm()
        ? Product.products.CASTerm.artDescription
        : `${secondaryPolicy.term} year Term`;
      return `${termText} Policy and Whole Life Policy`;
    } else {
      const primaryPolicy: CoverpathBasePolicy = application.primaryPolicy;
      if (primaryPolicy.isWholeLifePolicy()) {
        return `WL ${primaryPolicy.term}`;
      } else {
        return primaryPolicy.isAnnuallyRenewableTerm()
          ? Product.products.CASTerm.artDescription
          : `${primaryPolicy.term}-year Term`;
      }
    }
  }
}
